import React from "react";
import NavBar from "./NavBar";
import Greet from "./Greet";
import Projects from "./Projects";
import Experience from "./Experience";

class Main extends React.Component<{}, { greetedv: boolean }> {
	state = { greetedv: false };

	greeted() {
		let ret: boolean = this.state.greetedv;
		this.setState(state => ({
			greetedv: true
		}));
		return ret;
	}

	render() {
		return (
			<div className="MainWrapper">
				<header>
					<NavBar />
				</header>

				<div className="content">
					<div className="container">
						<Greet
							greeted={this.greeted.bind(
								this
							)}
						/>
						<Experience />
						<Projects />
					</div>
				</div>
			</div>
		);
	}
}

export default Main;
